'use strict';

module.exports = ['$translate', function roleListHelper ($translate) {
    return function (roleList, callback) {
        callback = callback || function (role) {
            return role;
        };

        var selected = [];
        angular.forEach(roleList, function (role) {
            selected.push(callback(role));
        });
        return (roleList && roleList.length > 0) ? selected.join(" , ") :
                $translate.instant('jdro_common.not_set_more');
    };
}];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/filters/RoleListHelper.js
// module id = 403
// module chunks = 0